var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomCarSecondary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "30px",
    height: "30px",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.585 12.86 22.11 7.89A2.609 2.609 0 0 0 19.608 6H9.756a2.578 2.578 0 0 0-2.503 1.89L5.78 12.86a2.677 2.677 0 0 0-1.58 2.431v5.312a1.32 1.32 0 0 0 1.314 1.332v1.333A1.32 1.32 0 0 0 6.827 24.6h1.314a1.32 1.32 0 0 0 1.313-1.332v-1.333h10.492v1.333a1.32 1.32 0 0 0 1.313 1.332h1.314a1.32 1.32 0 0 0 1.313-1.332v-1.333a1.32 1.32 0 0 0 1.314-1.332V15.29c-.036-1.098-.692-2.035-1.615-2.43zM9.756 8.647h9.852l1.172 3.997H8.567l1.19-3.997zm-.32 9.975a1.32 1.32 0 0 1-1.313-1.332 1.32 1.32 0 0 1 1.314-1.333 1.32 1.32 0 0 1 1.313 1.333 1.32 1.32 0 0 1-1.313 1.332zm10.492 0a1.32 1.32 0 0 1-1.314-1.332 1.32 1.32 0 0 1 1.314-1.333 1.32 1.32 0 0 1 1.313 1.333c-.017.738-.603 1.332-1.313 1.332z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomCarSecondary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-car-secondary.10e009364a11a3ea9c500515fc86d5cf.svg";